import { animate, AnimationTriggerMetadata, state, style, transition, trigger } from '@angular/animations';

import { IAnimationOptions } from '../_interfaces/animate.interface';

const DEFAULT_DURATION = 0;

export function displayAnimation(options?: IAnimationOptions): AnimationTriggerMetadata {
  return trigger((options && options.anchor) || 'displayInOut', [
    state(
      'none',
      style({
        display: 'none'
      })
    ),
    state(
      'block',
      style({
        display: 'block'
      })
    ),
    state(
      'flex',
      style({
        display: 'flex'
      })
    ),
    transition('none => block', [animate('{{durationIn}}ms {{delayIn}}ms')], {
      params: {
        delayIn: (options && options.delayIn) || 0,
        durationIn: (options && options.durationIn) || DEFAULT_DURATION
      }
    }),
    transition('block => none', [animate('{{durationOut}}ms {{delayOut}}ms')], {
      params: {
        delayOut: (options && options.delayOut) || 0,
        durationOut: (options && options.durationOut) || DEFAULT_DURATION
      }
    }),
    transition('none => flex', [animate('{{durationIn}}ms {{delayIn}}ms')], {
      params: {
        delayIn: (options && options.delayIn) || 0,
        durationIn: (options && options.durationIn) || DEFAULT_DURATION
      }
    }),
    transition('flex => none', [animate('{{durationOut}}ms {{delayOut}}ms')], {
      params: {
        delayOut: (options && options.delayOut) || 0,
        durationOut: (options && options.durationOut) || DEFAULT_DURATION
      }
    })
  ]);
}
